export default "__VITE_ASSET__DzUhi1G5__"